// =============================
// 右パネル切り替え & スライドアニメーション
// =============================

document.addEventListener('DOMContentLoaded', function () {

  const navBtns = document.querySelectorAll('.nav-btn[data-panel]');
  const panels = document.querySelectorAll('.right-panel');
  const centerContent = document.querySelector('.custom-center');

  // 現在のページに応じてアクティブナビを設定
const currentPath = window.location.pathname;

let currentPanel = 'home';

if (
  currentPath.includes('/collections/mizumushi') ||
  currentPath.includes('/collections/liquid-type') ||
  currentPath.includes('/collections/cream-type') ||
  currentPath.includes('/collections/nayami-yubi-jukujuku') ||
  currentPath.includes('/collections/ashiura') ||
  currentPath.includes('/collections/kakato') ||
  currentPath.includes('/collections/tsume')
) {
  currentPanel = 'mizumushi';
} else if (currentPath.includes('/collections/footcare')) {
  currentPanel = 'footcare';
} else if (currentPath.includes('/collections/nailcare')) {
  currentPanel = 'nailcare';
} else if (currentPath.includes('/collections/all_products')) {
  currentPanel = 'all_products';
}

navBtns.forEach(btn => {
  if (btn.getAttribute('data-panel') === currentPanel) {
    btn.classList.add('active');
  } else {
    btn.classList.remove('active');
  }
});

  // PC用：左右ナビゲーションと右パネル切り替え
  if (window.matchMedia('(min-width: 769px)').matches) {
    showPanel(currentPanel);

    // ナビボタンクリック
    navBtns.forEach(btn => {
      btn.addEventListener('click', function (e) {
        const panelId = this.getAttribute('data-panel');
        const href = this.getAttribute('href');

        // アクティブ切り替え
        navBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        // 右パネル切り替え
        showPanel(panelId);

        // スライドアニメーション付きページ遷移
        if (href && href !== '#') {
          e.preventDefault();
          centerContent.classList.add('slide-in-right');

          setTimeout(() => {
            window.location.href = href;
          }, 350);
        }
      });
    });

        function showPanel(panelId) {
      panels.forEach(p => p.classList.remove('active'));
      const target = document.getElementById('panel-' + panelId);

      if (target) {
        target.classList.add('active');
      }
    }

    // PCだけ、ページ読み込み時に左から表示する
    if (centerContent) {
      centerContent.classList.add('slide-in-left');
    }
  
  }

});

// =============================
// 商品画像拡大モーダル：スマホはどこをタップしても閉じる
// =============================
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (window.innerWidth > 768) return;

    const modal = document.querySelector('.product-media-modal[open]');
    if (!modal) return;

    // 拡大ボタンを押した瞬間のクリックでは閉じない
    if (event.target.closest('.product__media-toggle')) return;

    // 閉じるボタンがあれば、それを押す
    const closeButton = modal.querySelector('.product-media-modal__toggle');

    if (closeButton) {
      closeButton.click();
    } else {
      modal.removeAttribute('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }
  });
});